<script setup>
// Club-page cell for a Meet (equivalent of LeagueClickableCell etc.):
// "Meet · every Wednesday · £6.50" from the MeetListResponse.
import {computed} from 'vue';
import ClickableCell from '@/components/lists/ClickableCell';
import {useMeetFormat} from '~/composables/useMeetFormat';
import {meetCardLine} from '~/utils/competitionCard';

const props = defineProps({
  meet: {
    type: Object,
    default: () => null
  }
});

const {recurrenceText, isPaid, feeText} = useMeetFormat();

// X213: "Meet · Tennis · every Wednesday · £6.50 · 4 players"; nobody yet = "Open to join" when it has a link
const subtitle = computed(() => meetCardLine(props.meet, {
  recurrence: recurrenceText(props.meet),
  fee: isPaid(props.meet) ? feeText(props.meet) : 'free',
}));
</script>

<template>
  <clickable-cell
      icon="mdi-handshake"
      tone="meet"
      class="mb-3"
      :to="{ name: 'MeetDetail', params: { meetId: meet.id } }"
      :title="meet.name"
      :subtitle="subtitle"
      subtitle-one-line
  />
</template>
